module.exports = __webpack_public_path__ + "static/media/Thatsit_new.52a7bdf9.png";